var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.val)?_c('div',{staticClass:"home-solution-provider-list"},_vm._l((_vm.providerData),function(item){return _c('div',{key:item.id},[_c('span',[(item.attachmentList)?_c('v-img',{attrs:{"attachment-id":item.attachmentList ? item.attachmentList[0].id : '',"default-img":require('@/assets/img/nogs.png')}}):_c('span',{class:{
          'provider-color1': item.randNum == 1,
          'provider-color2': item.randNum == 2,
          'provider-color3': item.randNum == 3,
          'provider-color4': item.randNum == 4,
        }},[_vm._v(_vm._s(item.isvName.substr(0, 1)))])],1),_c('p',[_vm._v(_vm._s(item.isvName))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }